import {createSvgIcon} from '../create-svg-icon';

export const CommentBankIcon = createSvgIcon(
  [<path d="M18 14V6h-5v8l2.5-1.5z" key="0" />,<path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" key="1" />,]
, 'CommentBankOutlined');
